import '../common/init/minimal';
import sd, { registry } from '../common/init/serviceDiscoveryNoWindow';
import '../common/init/portal';
import Vue from 'vue';
import css from './index.css';
import comp from './index.vue';
import deployment from '../../PublisherPortal/App_Data/deployment';
import fetchJson from '../common/fetchJson';
import domready from './domready';
import xenv from './my.env';
import scrollbarWidth from './scrollbarWidth';

let baseConfig = null;
const customElementsSupported = window.customElements && window.customElements.define;

function convertDataset (defaults, attrs) {
    const rv = Object.assign({}, defaults);
    for (let i = 0; i < attrs.length; i++) {
        if (attrs[i].name.substring(0, 5) !== 'data-') {
            continue;
        }
        const path = attrs[i].name.substring(5).toLowerCase().split('-');
        let cur = rv;
        while (path.length > 1) {
            const elem = path.splice(0, 1)[0];
            if (!cur[elem]) {
                cur[elem] = {};
            }
            cur = cur[elem];
        }
        cur[path[0]] = attrs[i].value;
    }
    return rv;
}

const constructorImpl = function (el) {
    this._self = el || this;
    this._shadowRootMode = !!this._self.attachShadow;
    this._self.style.display = 'block';
    this._self.className = 'cld-bz-series-embed-injected';
    if (this._self.style.position === 'static' || !this._self.style.position) {
        this._self.style.position = 'relative';
    }
    // Загрузим json-модель коллекции
    baseConfig.then((cf) => {
        const conf = Object.assign({}, cf);
        return fetchJson(conf.RootDomain + this._self.dataset.src + '?json=true', 'GET').then((model) => {
            if (!model.Success) {
                throw new Error();
            }
            return Object.assign({}, cf, {
                SeriesModel: model.Model,
                DisplaySettingsOverride: convertDataset({
                    maxbooksperrow: -1,
                    background: { enabled: false },
                    header: { enabled: false, margin: 0 },
                }, this._self.attributes),
            });
        });
    }).then((cf) => {
        cf.SeriesModel.embeddingMode = 'noFrame';
        if (this._self.style.height === 'auto' || !this._self.style.height) {
            cf.SeriesModel.embeddingMode += 'Fluid';
        }

        // xenv.cdn = 'http://localhost:37873/Content/dist/';

        if (this._shadowRootMode) {
            // Создаём shadow-tree
            this._root = this._self.attachShadow({ mode: 'open' });

            // Это визуальный корневой контейнер
            const container = document.createElement('div');
            container.className = css.rootWrapper;
            this._root.appendChild(container);
            // Добавляем стили (в каждый shadow-root)
            const style = document.createElement('link');
            style.rel = 'stylesheet';

            if (xenv.cdn.substring(0, 4) === 'http') {
                style.href = xenv.cdn + 'embed-series.css';
            } else {
                style.href = cf.RootDomain + xenv.cdn + 'embed-series.css';
            }
            this._root.appendChild(style);

            // Ну, поехали!
            this.app = new Vue({
                el: container,
                render: h => h(comp, { props: { initialConfig: cf, host: this._self } }),
            });
        } else {
            // Режим совместимости, без shadow dom
            // Это визуальный корневой контейнер
            this._root = document.createElement('div');
            this._root.className = css.rootWrapper;

            while (this._self.firstChild) {
                this._self.removeChild(this._self.lastChild);
            }

            this._self.appendChild(this._root);
            this._self.className = css.rootWrapper;

            // Добавляем стили глобально, если ещё не сделали этого
            if (!window.__cldBzApi.stylesheetInjected) {
                const style = document.createElement('link');
                style.rel = 'stylesheet';
                if (xenv.cdn.substring(0, 4) === 'http') {
                    style.href = xenv.cdn + 'embed-series.css';
                } else {
                    style.href = cf.RootDomain + xenv.cdn + 'embed-series.css';
                }
                document.head.appendChild(style);
                window.__cldBzApi.stylesheetInjected = true;
            }

            // Ну, поехали
            this.app = new Vue({
                el: this._root,
                render: h => h(comp, { props: { initialConfig: cf, host: this._self } }),
            });
        }
    });
    // TODO: обработка ошибок загрузки JSON!!!!
};
let EmbedElement;
if (customElementsSupported) {
    EmbedElement = class extends HTMLElement {
        constructor (el) {
            super();
            constructorImpl.call(this, el);
        }
    };
} else {
    EmbedElement = function (el) {
        constructorImpl.call(this, el);
    };
}

window.__cldBzApi = window.__cldBzApi || {
    refreshLoops: 0,
};

if (!baseConfig) {
    // TODO: эти урлы надо бы захардкодить, делать по 4 запроса как-то излишне
    baseConfig = Promise.all([
        sd.GetApiRaw('Publ', 'pageserver'),
        sd.GetApiRaw('Publ', 'frontend-api'),
        sd.GetApiRaw('Publ', 'site'),
        sd.GetApi('generic', 'logon'),
    ]).then(urls => (
        {
            RootDomain: sd.Authority(urls[2][0], true),
            Logon: urls[3],
            Backend: urls[1][0].Host,
            Pageserver: urls[0][0].Host,
            Registry: registry,
            Deployment: deployment.ENVIRONMENT,
            Locale: 'en',
        }));
}
if ((window.__cldBzApi.scrollbarWidth === null || window.__cldBzApi.scrollbarWidth === undefined) && !window.__cldBzApi.scrollbarWidthScheduled) {
    window.__cldBzApi.scrollbarWidthScheduled = true;
    domready(() => {
        window.__cldBzApi.scrollbarWidth = scrollbarWidth();
    });
}
if (customElementsSupported) {
    // Если есть поддержка custom-elements воспользуемся ими - никакой дополнительной инициализации/обхода дерева не нужно
    window.customElements.define('cld-bz-series-embed', EmbedElement);
    window.__cldBzApi.refresh = () => {
    };
} else {
    // Ну, а если нет - то просто обойдём все элементы с классом cld-bz-series-embed во время DOMReady
    const realRefresh = () => {
        window.__cldBzApi.refreshLoops += 1;
        const elements = document.querySelectorAll('.cld-bz-series-embed');
        for (let i = 0; i < elements.length; i++) {
            elements[i].__cldBzEmbed = new EmbedElement(elements[i]);
        }
        window.__cldBzApi.refreshTimeout = null;
    };
    window.__cldBzApi.refresh = () => {
        if (window.__cldBzApi.refreshTimeout) {
            clearTimeout(window.__cldBzApi.refreshTimeout);
        }
        window.__cldBzApi.refreshTimeout = setTimeout(realRefresh, 250);
    };
    domready(() => window.__cldBzApi.refresh());
    /* if (!/in/.test(document.readyState)) {
        window.__cldBzApi.refresh();
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            window.__cldBzApi.refresh();
        });
    } */
}
